import React from 'react';

import styles from './talent.module.scss';
import { sanitizeHtml } from 'utils/sanitizeHtml';

export const TalentJobs = ({ content }) => (
  <div className={styles.talentJobs}>
    <div className={styles.singleItem} dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />
  </div>
);
